import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AdminFinancial from 'services/AdminFinancial'
import Comission from 'services/Comission'
import General from 'services/General'
import Select from 'components/Inputs/Select'
import DateInput from 'components/Inputs/DateInput'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  SubContainer,
  InfoContainer,
  FilterContainer,
  LabelRow,
  SubTitle,
  MoneyTextMask
} from '../styles'

export default function Earnings () {
  const now = DateTime.now ().setLocale ('pt-BR')
  const STATUS_LIST = [
    {label: 'Pagas', value: 'paid'},
    {label: 'A pagar', value: 'pending'},
    {label: 'Canceladas', value: 'canceled'}
  ]

  const [loading, setLoading] = useState (true)
  const [billsByDay, setBillsByDay] = useState ([])
  const [totalEarnings, setTotalEarnings] = useState (0)
  const [monthExpenses, setMonthExpenses] = useState (0)
  const [schedulesByDay, setSchedulesByDay] = useState ([])
  const [dateRange, setDateRange] = useState ([
    now.startOf ('month').toISODate (),
    now.toISODate ()
  ])
  const startDate = dateRange ? dateRange[0] : null
  const endDate = dateRange ? dateRange[1] : null
  const [status, setStatus] = useState (
    JSON.parse (localStorage.getItem ('bill_status')) || STATUS_LIST[0]
  )
  const token = AuthService.getToken ()
  const cutileiFilter = { value: 'cutilei' }

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [dateRange, status])

  const getData = async () => {
    setLoading (true)

    await getBills ()
    await getSchedulesByMonth ()

    setLoading (false)
  }

  const getBills = async () => {
    try {
      const { data: bills } = await cutileiApi.get (
        `/bills?start_date=${startDate}&end_date=${endDate}&status=${status.value}`,
        requestConfig
      )
      
      setTotalEarnings (AdminFinancial.getAdminEarnings (bills))
      setBillsByDay (General.groupBy (bills.map (bill => ({
        ...bill, day: DateTime.fromISO (bill.created_at).toISODate ()
      })), 'day'))
    } catch (error) {
      logApiError (error)
    }
  }

  const getSchedulesByMonth = async () => {
    const filters = `?order=desc&start_date=${startDate}&end_date=${endDate}`
                  + `&status=validated&cutilei_schedules=true&page=1&per_page=999999`

    try {
      const { data: scheduleResponse } = await cutileiApi.get (`/schedules${filters}`, requestConfig)

      const schedules = scheduleResponse.data.map (schedule => ({...schedule, type: 'cutilei'}))
      setMonthExpenses (Comission.getTotalEarnings (schedules, cutileiFilter, null))
      setSchedulesByDay (General.groupBy (schedules, 'date'))
    } catch (error) {
      logApiError (error)
    }
  }

  return (
    <SubContainer>
      <FilterContainer>
        <DateInput
          value={dateRange}
          selectRange={true}
          onChange={setDateRange}
        />
        <Select
          name='status'
          placeholder='Status...'
          value={status}
          options={STATUS_LIST}
          onChange={(_, option) => {
            setStatus (option)
            localStorage.setItem ('bill_status', JSON.stringify (option))
          }}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 20}}/> : (
        <>
          <LabelRow>
            <SubTitle>Dia</SubTitle>
            <SubTitle>Total bruto</SubTitle>
            <SubTitle>Gastos com salões</SubTitle>
            <SubTitle>Total Líquido</SubTitle>
          </LabelRow>
          {status.value === 'paid' ? (
            <InfoContainer style={{cursor: 'default'}}>
              <SubTitle>TOTAL DO PERÍODO</SubTitle>
              <MoneyTextMask value={totalEarnings}/>
              <MoneyTextMask value={monthExpenses}/>
              <MoneyTextMask value={(totalEarnings - monthExpenses)}/>
              <FA.FaChevronRight size={15} color='#252525'/>
            </InfoContainer>
          ) : null}
          {schedulesByDay.map ((daySchedules, index) => {
            const day = DateTime.fromISO (daySchedules[0].date).day
            const formattedDay = DateTime.fromISO (daySchedules[0].date).toFormat ('dd/MM/yyyy')
            const dayBills = billsByDay.find (bills => DateTime.fromISO (bills[0].day).day === day) || []
            const dayEarnings = AdminFinancial.getTotalBillEarnings (dayBills)
            const dayExpenses = Comission.getTotalEarnings (daySchedules || [], cutileiFilter)
            
            return (
              <InfoContainer
                key={index}
                to='/admin/earnings/daily'
                state={{ formattedDay, dayBills, daySchedules }}
              >
                <SubTitle>{formattedDay}</SubTitle>
                <MoneyTextMask value={dayEarnings}/>
                <MoneyTextMask value={dayExpenses}/>
                <MoneyTextMask value={dayEarnings - dayExpenses}/>
                <FA.FaChevronRight size={15} color='#252525'/>
              </InfoContainer>
            )
          })}
        </>
      )}
    </SubContainer>
  )
}
